export const addIntegrationMessages = {
  createIntegrationSuccess: 'Integration was created successfully.',
  createIntegrationStarting: 'Integration creation starting...',
  unknownIntegrationError: 'Something went wrong.',
};
